import React from 'react';

export type ScreenSize = 'small' | 'medium' | 'full-screen' | { width?: number, height: number };

export const ScreenSizeContext = React.createContext<ScreenSize | undefined>(undefined);

export const useScreenSize = () => {
	const context = React.useContext(ScreenSizeContext);
	return context;
};
